module.exports = __webpack_public_path__ + "images/sprites/ui/icons_list_ul_gray_197c73d79d17ef643a369d565bcda27a.png";